import Vue from 'vue'
import VueRouter from 'vue-router'
import { isSystem, requestWxStr } from '@/utils/custom';

Vue.use(VueRouter)

const routes = [
  {
    path: '/platformC',
    name: 'Home',
    meta: { title: '至尊宝-C端下载' },
    component: () => import('@/views/platformC.vue')
  },
  {
    path: '/platformB',
    name: 'Home',
    meta: { title: '至尊宝-B端下载' },
    component: () => import('@/views/platformB.vue')
  },
  {
    path: '/platformB/form',
    name: 'platformFormB',
    meta: { title: '代理注册' },
    component: () => import('@/views/platformFormB.vue')
  },
  {
    path: '/platformB/richText',
    name: 'richText',
    meta: { title: '协议' },
    component: () => import('@/views/richText.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
	base: '/zzb-api-register/',
  routes
})

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
